'use client'

import React from 'react'

import { Footer, Header, PageWrapper } from 'Components/Blocks'
import Content from 'Components/Sections/_Legacy/Policy'
import { Column, Row } from 'Components/UI'
import { PolicyPageData } from 'Data/types'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

type Props = {
  data: PolicyPageData
}

function PolicyPage({ data }: Props) {
  return (
    <PageWrapper secondary>
      <Header />

      <Column alignCenter fullWidth overflowX="hidden">
        <Row height={[76, 76, 92]} />
      </Column>

      <Column as="main" px={LANDING_INLINE_PADDINGS} py={7}>
        <Content data={data.policyPage} />
      </Column>

      <Footer />
    </PageWrapper>
  )
}

export default PolicyPage
